var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('h1',{staticClass:"mt-0 mb-3"},[_vm._v("Заказы")]),_c('OrdersTable'),_c('OrderBlock',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }